module.exports = __webpack_public_path__ + "img/mathematical-logic.8abc8d5c.png";